import { Salutation } from '../types/commons';

export const GENDER = {
  MAN: 'man',
  WOMAN: 'woman',
  MAN_VALUE: 'M.',
  WOMAN_VALUE: 'Mme',
};

export const GENDERS: { key: string; value: Salutation }[] = [
  {
    key: GENDER.WOMAN,
    value: 'Mme',
  },
  {
    key: GENDER.MAN,
    value: 'M.',
  },
];
